// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_CriarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/accounts/criar
 *
 * Creates a subaccount manually with existing provider credentials.
 * For creating new subaccounts via master account, use criar_subconta() instead.
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_CriarInput {
provider_id: number
name: string
email?: string
document?: string
document_type?: string
phone?: string
address?: unknown[]
api_key?: string
config?: unknown[]
fiscal_config?: unknown[]
sandbox_mode?: boolean
franchise_ids?: number[]
}

registerContract('SubaccountsFranchises_CriarInput', {
  provider_id:   { type: 'number',  required: true },
  name:          { type: 'string',  required: true },
  email:         { type: 'string',  required: false },
  document:      { type: 'string',  required: false },
  document_type: { type: 'string',  required: false },
  phone:         { type: 'string',  required: false },
  address:       { type: 'array',   required: false },
  api_key:       { type: 'string',  required: false },
  config:        { type: 'array',   required: false },
  fiscal_config: { type: 'array',   required: false },
  sandbox_mode:  { type: 'boolean', required: false },
  franchise_ids: { type: 'array',   required: false },
})
